import Image from 'next/image';
//Import react swiper component
import {Swiper, SwiperSlide} from 'swiper/react';
// import Swiper core and required modules
import {Swiper as SwiperInterface} from 'swiper';
import {Autoplay, Navigation, Thumbs} from 'swiper/modules';
// Import Swiper styles
import {useState} from 'react';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

import {ImageInterface} from '@interfaces/images';
import styles from './style.module.css';

export default function ImageCarousel(props: {
  images: ImageInterface[];
  swipeSlide?: boolean;
  height?: number;
  width?: number;
}) {
  const {images = [], swipeSlide = true, height = 700, width = 700} = props;
  const [thumbsSwiper, setThumbsSwiper] = useState<SwiperInterface>();
  return (
    <>
      <Swiper
        className={`${styles.productImageSwiper} product-detail-carousel`}
        modules={[Autoplay, Navigation, Thumbs]}
        autoplay={{
          delay: 10000,
        }}
        // effect={"fade"}
        fadeEffect={{
          crossFade: true,
        }}
        loop={true}
        spaceBetween={0}
        thumbs={
          images.length > 1
            ? {
                swiper: thumbsSwiper!,
                slideThumbActiveClass: styles.productActiveThumb as string,
              }
            : {}
        }
        navigation={images.length > 1}
      >
        {images.map((image, key) => {
          return (
            <SwiperSlide key={key} className={`${styles.swiperSlide}`}>
              <Image
                alt={`image ${key}`}
                src={image?.image}
                height={height}
                width={width}
              />
            </SwiperSlide>
          );
        })}

        {/*<SwiperSlide className={styles.swiperSlide}>*/}
        {/*    <Image  src={Image9} />*/}
        {/*</SwiperSlide>*/}
        {/*<SwiperSlide className={styles.swiperSlide}>*/}
        {/*    <Image  src={Image7} />*/}
        {/*</SwiperSlide>*/}
      </Swiper>
      {swipeSlide && thumbsSwiper && (
        <Swiper
          onSwiper={setThumbsSwiper}
          centerInsufficientSlides={true}
          spaceBetween={10}
          slidesPerView={'auto'}
          freeMode={true}
          watchSlidesProgress={true}
          slideActiveClass={styles.productActiveThumb}
          className={styles.productSwiperThumbs}
        >
          {images.map((image, key) => {
            return (
              <SwiperSlide key={key} className={styles.swiperSlide}>
                <Image
                  alt={image.image}
                  height={100}
                  width={100}
                  src={image.image}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      )}
    </>
  );
}
